if (!customElements.get('borever-fit')) {
  customElements.define('borever-fit', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-fit-variants]').textContent);
      this.groups = [...this.querySelectorAll('.bf-options')];
      this.heightInput = this.querySelector('[data-measure="height"]');
      this.bodyInput = this.querySelector('[data-measure="body"]');
      this.status = this.querySelector('.bf-status');
      this.contactLink = this.querySelector('[data-fit-contact]');
      this.statusInput = this.querySelector('[data-fit-status]');
      this.manual = true;
      const requestedVariantId = new URL(location.href).searchParams.get('variant');
      const requestedVariant = this.variants.find(variant => String(variant.id) === requestedVariantId);
      if (requestedVariant) {
        this.groups.forEach((group, index) => {
          group.querySelectorAll('input').forEach(input => {
            input.checked = input.value === requestedVariant.options[index];
          });
        });
      }
      this.inputHandler = () => { this.manual = false; this.autoSelect(); this.sync(); };
      this.changeHandler = (event) => {
        if (event.target.type !== 'radio') return;
        this.manual = true;
        this.sync();
      };
      this.addEventListener('input', event => { if (event.target.matches('[data-measure]')) this.inputHandler(); });
      this.addEventListener('change', this.changeHandler);
      this.submitHandler = event => {
        if (event.target.id !== this.dataset.form) return;
        this.sync();
        if (!this.variant) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.message(this.dataset.unavailable);
        }
      };
      this.info = this.closest('product-info');
      this.info.addEventListener('submit', this.submitHandler, true);
      const themeId = new URL(location.href).searchParams.get('preview_theme_id');
      this.querySelectorAll('a[target="_blank"]').forEach(link => {
        const url = new URL(link.href);
        if (url.searchParams.get('view') !== 'borever-measurements') return;
        const returnUrl = new URL(this.dataset.productUrl, location.origin);
        returnUrl.searchParams.set('view', 'borever-fit');
        if (themeId) {
          url.searchParams.set('preview_theme_id', themeId);
          returnUrl.searchParams.set('preview_theme_id', themeId);
        }
        url.searchParams.set('return_to', returnUrl.pathname + returnUrl.search);
        link.href = url.href;
      });
      requestAnimationFrame(() => this.sync());
    }
    disconnectedCallback() { this.info?.removeEventListener('submit', this.submitHandler, true); }
    parse(input) {
      const raw = input?.value.trim().replace(',', '.');
      return raw && /^\d+(\.\d+)?$/.test(raw) ? Number(raw) : null;
    }
    choose(kind, value) {
      const group = this.groups.find(group => group.dataset.kind === kind);
      group?.querySelectorAll('input').forEach(input => { input.checked = input.value === value; });
    }
    autoSelect() {
      this.choose('size', null); this.choose('height', null);
      const height = this.parse(this.heightInput), body = this.parse(this.bodyInput);
      if (!height || !body) return;
      const chart = this.dataset.kind === 'waist'
        ? [[70,77,'XS'],[77,84,'S'],[84,91,'M'],[91,98,'L'],[98,105,'XL'],[105,114,'XXL']]
        : [[69,78,'XS'],[78,87,'S'],[87,96,'M'],[96,105,'L'],[105,114,'XL'],[114,123,'XXL']];
      const size = chart.find(([min,max]) => body >= min && body < max)?.[2];
      const heightGroup = this.groups.find(group => group.dataset.kind === 'height');
      const value = [...(heightGroup?.querySelectorAll('input') || [])].find(input => {
        const bounds = input.value.match(/\d+/g)?.map(Number);
        return bounds?.length === 2 && height >= bounds[0] && height < bounds[1] + 1;
      })?.value;
      if (size && value) { this.choose('size', size); this.choose('height', value); }
    }
    message(text) { this.status.textContent = text || ''; this.status.hidden = !text; }
    sync() {
      const choices = this.groups.map(group => group.querySelector('input:checked')?.value || null);
      const complete = choices.every(Boolean);
      const matches = variant => choices.every((choice,index) => !choice || variant.options[index] === choice);
      this.variant = this.variants.find(variant => variant.available && matches(variant));
      if (!this.variant && !complete && choices.every(choice => !choice)) this.variant = this.variants.find(variant => variant.available);
      const form = document.getElementById(this.dataset.form);
      const id = form?.querySelector('[name="id"]');
      if (id && this.variant) {
        const changed = id.value !== String(this.variant.id);
        id.value = this.variant.id; id.disabled = false;
        if (changed) id.dispatchEvent(new Event('change', {bubbles:true}));
      }
      const productForm = this.info.querySelector('product-form');
      productForm?.toggleSubmitButton?.(!this.variant, !this.variant ? window.variantStrings?.unavailable : undefined);
      this.statusInput.value = complete ? (this.manual ? this.dataset.statusManual : this.dataset.statusAuto) : this.dataset.statusPending;
      const outside = !this.manual && !complete && !!this.heightInput?.value.trim() && !!this.bodyInput?.value.trim();
      if (this.contactLink) this.contactLink.hidden = !outside;
      if (!this.variant) this.message(this.dataset.unavailable);
      else if (complete) this.message('');
      else if (!this.manual && (this.heightInput?.value || this.bodyInput?.value)) {
        this.message(this.heightInput.value && this.bodyInput.value ? this.dataset.outside : this.dataset.partial);
      } else this.message('');
      if (this.variant) {
        const price = this.info.querySelector('[id^="price-"]');
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'uk', {style:'currency',currency:window.Shopify?.currency?.active || 'UAH',maximumFractionDigits:0}).format(this.variant.price / 100);
        const sale = this.variant.compare_at_price > this.variant.price;
        price?.querySelector('.price')?.classList.toggle('price--on-sale', sale);
        const current = price?.querySelector(sale ? '.price-item--sale' : '.price__regular .price-item--regular');
        if (current) current.textContent = formatted;
        const old = price?.querySelector('.price__sale .price-item--regular');
        if (old && sale) old.textContent = new Intl.NumberFormat(document.documentElement.lang || 'uk', {style:'currency',currency:window.Shopify?.currency?.active || 'UAH',maximumFractionDigits:0}).format(this.variant.compare_at_price / 100);
        const media = this.variant.featured_media?.id;
        if (media && media !== this.lastMedia) this.info.querySelector('media-gallery')?.setActiveMedia?.(`${this.dataset.section}-${media}`, true);
        this.lastMedia = media;
      }
    }
  });
}
